import vuxDateFormat from 'vux/src/tools/date/format.js'


/*
* 时间格式截取
* params format(string) YYYY-MM-DD HH:mm
* output 2016-05-31 10:00
* */
export function dateFormat(date, pattern = 'YYYY-MM-DD') {
return vuxDateFormat(date, pattern);
}



// WEBPACK FOOTER //
// ./src/utils/filters.js